import { render, staticRenderFns } from "./DeliveryServiceSelector.vue?vue&type=template&id=1075d911&scoped=true&"
import script from "./DeliveryServiceSelector.vue?vue&type=script&lang=js&"
export * from "./DeliveryServiceSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1075d911",
  null
  
)

export default component.exports